import { SET_FEATURE_FLAGS } from './types';
export var setFeatureFlags = function setFeatureFlags(enabledFeatures) {
  return {
    type: SET_FEATURE_FLAGS,
    payload: enabledFeatures
  };
};